import { createAction } from 'redux-actions'

export const SET_WIDGETS = createAction('SET_WIDGETS')
